/** "Còn 3 ảnh trước bạn, khoảng 2 phút" under a waiting job or batch (server availability.py: queue_position, eta_s,
 * sent while the job is queued). Not a live region: it changes at every poll. */
import { QUEUE } from "../messages";

interface Props {
  position?: number | null;
  eta?: number | null;
  batch?: boolean;
  className?: string;
}

export function QueueWait({ position, eta, batch = false, className = "hint" }: Props) {
  if (position === undefined || position === null) return null;
  return (
    <p className={[className, "queue-wait"].filter(Boolean).join(" ")}>
      {batch ? QUEUE.batchWait(position, eta) : QUEUE.wait(position, eta)}
    </p>
  );
}
